module.exports = __webpack_public_path__ + "static/logo-8906f07d8e3418cdf9196cb905e8efaf.png";